import DateTimeOrNoData from 'components/content/DateTimeOrNoData';
import NoData from 'components/content/NoData';
import SimulationStateBadge from 'features/simulations-v2/SimulationStateBadge';
import type { SimulatedVehicleTO } from 'features/simulations-v2/types';

import './_styles.scss';

interface SimulationsV2RowProps {
    simulation: SimulatedVehicleTO;
    scenarioNames: Map<string, string>;
}

const SimulationsV2Row = ({ simulation, scenarioNames }: SimulationsV2RowProps) => (
    <tr className='SimulationsV2Row' data-testid='simulations-v2-row'>
        <td className='SimulationsV2Row__column' data-testid='simulations-v2-row-vin'>
            {simulation.vin}
        </td>
        <td className='SimulationsV2Row__column' data-testid='simulations-v2-row-scenarioName'>
            {(simulation.scenarioId && scenarioNames.get(simulation.scenarioId)) ?? <NoData className='text-14' />}
        </td>
        <td className='SimulationsV2Row__column' data-testid='simulations-v2-row-state'>
            <SimulationStateBadge state={simulation.state} />
        </td>
        <td className='SimulationsV2Row__column' data-testid='simulations-v2-row-startedAt'>
            <DateTimeOrNoData value={simulation.startedAt} />
        </td>
    </tr>
);

export default SimulationsV2Row;
